import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import keycloak from './utils/keycloak';
import * as serviceWorker from './serviceWorker';
import App from './App';

// Get the root element
const container = document.getElementById('root');
const root = createRoot(container);

// Initialize Keycloak
keycloak.init({
  onLoad: 'login-required',
  checkLoginIframe: false,
  checkLoginIframeInterval: 0,
  pkceMethod: 'S256'
}).then((authenticated) => {
  console.log('Keycloak initialized:', authenticated);
  
  root.render(
    <BrowserRouter>
      <App keycloak={keycloak} />
    </BrowserRouter>
  );
}).catch((error) => {
  console.error('Keycloak initialization failed:', error);
  root.render(
    <BrowserRouter>
      <App keycloak={keycloak} />
    </BrowserRouter>
  );
});

serviceWorker.unregister();
